<template>
  <form @submit.prevent="handleSubmit">
    <div class="input-container">
      <legend v-if="legend">{{ legend }}</legend>

      <div class="input-row">
        <input type="text" class="input" v-model="search" :placeholder="placeholder" :disabled="disabled">

        <button type="submit">
          <Magnify :size="18" />
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import Input from '../core/Input'
import Magnify from 'icons/Magnify'

export default {
  name: 'Search',
  components: {
    Input,
    Magnify,
  },
  props: {
    legend: {
      type: String,
    },
    placeholder: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
    }
  },
  data() {
    return {
      search: '',
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('submit:search', this.search)
    },
  }
}
</script>

<style lang="scss" scoped>
.input-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  legend {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 21.82px;
    color: #606264;
  }

  .input-row {
    box-sizing: border-box;
    height: 2.7375rem;
    border: 1px solid #EAEAEA;
    border-radius: 4px;

    display: flex;
    align-items: center;

    .input {
      flex: 1;
      background: transparent;
      border: 0;
      outline: 0;

      box-sizing: border-box;
      padding: 0.625rem;
      font-size: 1rem;
      font-weight: 600;
      line-height: 21.82px;

      &::placeholder {
        color: #D3D3D3;
      }

      &:disabled {
        cursor: not-allowed;
      }

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px white inset !important;
        -webkit-box-shadow: 0 0 0px 1000px white inset !important;
      }
    }

    button {
      all: unset;
      padding-right: 0.625rem;
      cursor: pointer;
      color: #1C2D5A;
    }
  }
}
</style>